// export const HOST = "http://localhost:9000/";


export const HOST = "https://musee-loukach.ma/backend/";